export const SET_STATE = 'SET_STATE';
export const INC_STATE = 'INC_STATE';
export const SET_ACTIVE_CAMERA = 'SET_ACTIVE_CAMERA';
export const CLEAR_ACTIVE_CAMERA = 'CLEAR_ACTIVE_CAMERA';
export const LINK_TV_VIDEO = 'LINK_TV_VIDEO';
export const LINK_VIDEO = 'LINK_VIDEO';
export const UNLINK_VIDEO = 'UNLINK_VIDEO';
export const ADD_OPTIONS = 'ADD_OPTIONS';
export const RESET = 'RESET';
export const SET_LOADING = 'SET_LOADING';
export const SET_VIDEO_TYPE = 'SET_VIDEO_TYPE';

export default {
  SET_STATE,
  INC_STATE,
  SET_ACTIVE_CAMERA,
  CLEAR_ACTIVE_CAMERA,
  LINK_TV_VIDEO,
  LINK_VIDEO,
  UNLINK_VIDEO,
  ADD_OPTIONS,
  RESET,
  SET_LOADING,
  SET_VIDEO_TYPE,
};
